// extracted by mini-css-extract-plugin
export var actions = "_s9-4";
export var item = "_s9-1";
export var price = "_s9-3";
export var quantity = "_s9-2";
export var table = "_s9-0";